import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Store Pages
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import OrdersPage from "./pages/OrdersPage";
import LoginPage from "./pages/LoginPage";
import PrivatePolicyPage from './pages/PrivatePolicyPage';
import FacebookCallback from "./pages/FacebookCallback";
import TrackOrderPage from "./pages/TrackOrderPage";
import CakeCustomizer from "./pages/CakeCustomizer";

// Admin Pages
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminCategories from "./pages/admin/AdminCategories";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminFlashSales from "./pages/admin/AdminFlashSales";
import AdminColors from "./pages/admin/AdminColors";
import AdminSizes from "./pages/admin/AdminSizes";

//Megamart Plug Pages
import { PlugLanding } from "./components/PlugLanding";
import { AirFryerPlug } from "./components/AirFryerPlug";
import { PressureCookerPlug } from "./components/PressureCookerPlug";
import { BlenderPlug } from "./components/BlenderPlug";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Store Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/products/:id" element={<ProductDetailPage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/checkout" element={<CheckoutPage />} />
          <Route path="/orders" element={<OrdersPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/privacy-policy" element={<PrivatePolicyPage />} />
          <Route path="/facebook/callback" element={<FacebookCallback />} />
          <Route path="/track/:order_number" element={<TrackOrderPage />} />
          <Route path="/customize/:id" element={<CakeCustomizer />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/products" element={<AdminProducts />} />
          <Route path="/admin/categories" element={<AdminCategories />} />
          <Route path="/admin/orders" element={<AdminOrders />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/flash-sales" element={<AdminFlashSales />} />
          <Route path="/admin/colors" element={<AdminColors />} />
          <Route path="/admin/sizes" element={<AdminSizes />} />

          {/* Megamart Plug Routes */}
          <Route path="/plug" element={<PlugLanding />} />
          <Route path="/plug/air-fryer" element={<AirFryerPlug />} />
          <Route path="/plug/pressure-cooker" element={<PressureCookerPlug />} />
          <Route path="/plug/blender" element={<BlenderPlug />} />

        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
